import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const SearchNotFoundIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 74 74" {...props}>
            <path
                fill="none"
                d="M64.8008 65.3L46.8008 47.3"
                stroke="currentColor"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fill="none"
                d="M23.4004 35.7798L5.40039 53.7798"
                stroke="currentColor"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fill="none"
                d="M5.40039 35.7798L23.4004 53.7798"
                stroke="currentColor"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.4837 28.3999C14.74 19.6361 22.2781 12.8999 31.3894 12.8999C41.3801 12.8999 49.4791 20.9989 49.4791 30.9896C49.4791 40.6412 41.9204 48.5274 32.3997 49.0515V54.0575C44.6831 53.5287 54.4791 43.4031 54.4791 30.9896C54.4791 18.2375 44.1415 7.8999 31.3894 7.8999C19.5128 7.8999 9.73054 16.8668 8.44336 28.3999H13.4837Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};
